/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoIcon16Solid = forwardRef('TechCamVideoIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.5 3A2.5 2.5 0 0 0 0 5.5v5A2.5 2.5 0 0 0 2.5 13h6a2.5 2.5 0 0 0 2.5-2.5v-1l3.427 2.399a1 1 0 0 0 1.573-.82V4.921a1 1 0 0 0-1.573-.82L11 6.5v-1A2.5 2.5 0 0 0 8.5 3h-6Z" })));
});
